export default __webpack_public_path__ + "static/ex4-signature-d5f79198861bb34f2d34a3814183d841.webp";